<template>
  <sub-menu :links="links" :active="active"></sub-menu>
</template>

<script>
import Meta from '@/mixins/Meta'
import Permissions from '@/mixins/Permissions'
import SubMenu from '@/components/Layout/SubMenu'
import FileAltIcon from "../../../../components/Icons/Old/FileAltIcon.vue";
import ColumnsIcon from "../../../../components/Icons/Old/ColumnsIcon.vue";
import NewspaperIcon from "../../../../components/Icons/Old/NewspaperIcon.vue";
import CalendarIcon from "../../../../components/Icons/Old/CalendarIcon.vue";
import ToolboxIcon from "../../../../components/Icons/Old/ToolboxIcon.vue";
import UsersIcon from "../../../../components/Icons/Old/UsersIcon.vue";
import ObjectGroupIcon from "../../../../components/Icons/Old/ObjectGroupIcon.vue";
import LayerGroupIcon from "../../../../components/Icons/Old/LayerGroupIcon.vue";
import TagsIcon from "../../../../components/Icons/Old/TagsIcon.vue";
import BarsIcon from "../../../../components/Icons/Old/BarsIcon.vue";
import SitemapIcon from "../../../../components/Icons/Old/SitemapIcon.vue";

export default {
  components: {SubMenu},

  mixins: [Meta, Permissions],

  props: ['portal'],

  computed: {
    links() {
      return [
        {
          id: 'dashboard',
          url: '/portals/' + this.portal.id,
          text: 'Dashboard'
        },
        {
          id: 'channels',
          url: '/portals/' + this.portal.id + '/channels',
          text: 'Channels',
          display: this.hasPermission('admin')
        },
        {
          id: 'budget',
          url: '/portals/' + this.portal.id + '/budget',
          text: 'Subscription Budget',
          display: this.hasPermission('admin')
        },
        {
          id: 'subscription-types',
          url: '/portals/' + this.portal.id + '/subscription-types',
          text: 'Subscription Types',
          display: this.hasPermission('admin')
        },
        {
          id: 'mailing-lists',
          url: '/portals/' + this.portal.id + '/mailing-lists',
          text: 'Mailing Lists',
          display: this.hasPermission('admin')
        },
        {
          id: 'magazine-recipients',
          url: '/portals/' + this.portal.id + '/magazine-recipients',
          text: 'Magazine Recipients',
          display: this.hasPermission('admin')
        },
        {
          id: 'content',
          text: 'Content',
          links: [
            {
              url: '/portals/' + this.portal.id + '/content',
              text: 'Dashboard'
            },
            {
              url: '/portals/' + this.portal.id + '/content/pages',
              text: 'Pages'
            },
            {
              url: '/portals/' + this.portal.id + '/content/layouts',
              text: 'Layouts'
            },
            {
              url: '/portals/' + this.portal.id + '/content/articles',
              text: 'Articles'
            },
            {
              url: '/portals/' + this.portal.id + '/content/events',
              text: 'Events'
            },
            {
              url: '/portals/' + this.portal.id + '/content/jobs',
              text: 'Jobs'
            },
            {
              url: '/portals/' + this.portal.id + '/content/topics',
              text: 'Topics'
            },
            {
              url: '/portals/' + this.portal.id + '/content/article-categories',
              text: 'Article Categories'
            },
            {
              url: '/portals/' + this.portal.id + '/content/event-categories',
              text: 'Event Categories'
            },
            {
              url: '/portals/' + this.portal.id + '/content/article-tags',
              text: 'Article Tags'
            },
            {
              url: '/portals/' + this.portal.id + '/content/article-labels',
              text: 'Article Labels'
            },
            {
              url: '/portals/' + this.portal.id + '/content/article-flags',
              text: 'Article Flags'
            },
            {
              url: '/portals/' + this.portal.id + '/content/article-flag-schedules',
              text: 'Article Flag Schedules'
            },
            {
              url: '/portals/' + this.portal.id + '/content/top-menu-links',
              text: 'Top Menu Links'
            },
            {
              url: '/portals/' + this.portal.id + '/content/primary-menu-links',
              text: 'Primary Menu Links'
            },
            {
              url: '/portals/' + this.portal.id + '/content/secondary-menu-links',
              text: 'Secondary Menu Links'
            },
            {
              url: '/portals/' + this.portal.id + '/content/sitemap-links',
              text: 'Sitemap Links'
            },
            {
              url: '/portals/' + this.portal.id + '/content/colors',
              text: 'Colors'
            },
            {
              url: '/portals/' + this.portal.id + '/content/job-regions',
              text: 'Job Regions'
            },
            {
              url: '/portals/' + this.portal.id + '/content/registration-categories',
              text: 'Registration Categories'
            },
            {
              url: '/portals/' + this.portal.id + '/content/registrations',
              text: 'Registrations'
            },
            {
              url: '/portals/' + this.portal.id + '/content/file-categories',
              text: 'File Categories'
            },
            {
              url: '/portals/' + this.portal.id + '/content/files',
              text: 'Files'
            },
            {
              url: '/portals/' + this.portal.id + '/content/search-suggestions',
              text: 'Search Suggestions'
            },
          ]
        },
        {
          id: 'edit',
          url: '/portals/' + this.portal.id + '/edit',
          text: 'Edit',
          display: this.hasPermission('admin')
        }
      ]
    },

    active() {
      return this.getMeta('subsection')
    }
  }
}
</script>
